import React, {createContext, useContext, useEffect, useState} from 'react';
import translations from './translations';
import {fallbackLocale} from './i18n';
import {useAppConfiguration} from '../AppConfiguration';

const LanguageContext = createContext();

export function useLang() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    const {lang, setLang} = context;

    return {lang, setLang};
}

export const LanguageProvider = ({ children }) => {
    const language = window.localStorage.getItem('language');
    const {isWidget} = useAppConfiguration();
    const [lang, setLang] = useState((language && !isWidget) ? language : fallbackLocale);

    useEffect(() => {
        // We dont wanna update the local storage when the page is visited over the iframe
        if (!isWidget) {
            window.localStorage.setItem('language', lang);
        }
    }, [lang, isWidget]);

    return (
        <LanguageContext.Provider value={{lang, setLang}}>
            {children}
        </LanguageContext.Provider>
    );
};


export const useTranslation = (id, params) => {
    const {lang} = useLang();

    const translation = translations[lang][id] || id;

    return typeof translation === 'function' ? translation(params) : translation;
};

export const Translate = ({value, ...params}) => useTranslation(value, params);
